import { useLanguageSwitcher } from '@hantecmarket/widget-core'
import ButterCMS from 'buttercms'

import { useGlobalPreview } from '@/composables/useGlobalPreview'

const butter = ButterCMS(import.meta.env.VITE_BUTTERCMS_API_KEY, { timeout: 60000 })

// TODO fix params type
const Repository = (endpoint: string, type: string, queryParams: any = {}) => {
  const { getLocale } = useLanguageSwitcher()

  const globalPreview = useGlobalPreview()

  if (globalPreview) {
    localStorage.setItem('preview', '1')
  }
  let lang = getLocale()
  if (lang === 'jp') {
    lang = 'ja'
  }
  const params = {
    locale: lang ?? 'en',
    preview: localStorage.getItem('preview'),
    ...queryParams
  }

  // Ensure that the type
  // lid method on the butter instance
  if (type !== 'post_by_slug' && typeof butter[type]?.retrieve !== 'function') {
    throw new Error(`Invalid type: ${type}`)
  }

  const [mainEndpoint, secondaryEndpoint] = endpoint.includes('|')
    ? endpoint.split('|')
    : [endpoint, null]

  if (type === 'content') {
    return butter[type].retrieve(mainEndpoint.split('/'), params)
  } else if (type === 'page') {
    if (secondaryEndpoint) return butter[type].retrieve(mainEndpoint, secondaryEndpoint, params)
    return butter[type].retrieve('*', mainEndpoint, params)
  } else if (type === 'post') {
    const blogs = butter.page.list('blogs', {
      ...params
    })
    return blogs
  } else if (type === 'post_by_slug') {
    const blogs = butter.page.retrieve('blogs', mainEndpoint, {
      ...params
    })
    return blogs
  } else {
    if (secondaryEndpoint) return butter[type].retrieve(mainEndpoint, secondaryEndpoint, params)
    return butter[type].retrieve('*', mainEndpoint, params)
  }
}

export default Repository
